/**
 * Shared login flow — fineri:login event, KwikPass adapter when present, Shopify fallback otherwise.
 */
(function () {
  'use strict';

  if (window.__fineriLoginFlow) return;
  window.__fineriLoginFlow = true;

  var FALLBACK_MS = 1500;
  var kpRetryTimer = 0;
  var LOGIN_TRIGGER_SELECTOR =
    '[data-fineri-action="login"], [data-fineri-login="on"], [data-fineri-kwikpass-trigger], .fineri-header__icons button.fineri-header__icon--account';

  function readCfg() {
    try {
      var el = document.getElementById('FineriStorefrontConfig');
      if (el) return JSON.parse(el.textContent);
    } catch (e) {}
    return {};
  }

  function shopifyCustomerLoggedIn() {
    return readCfg().customerLoggedIn === true;
  }

  function accountUrl() {
    var paths = readCfg().paths || {};
    return paths.account || '/account';
  }

  function accountLoginUrl() {
    var paths = readCfg().paths || {};
    return paths.accountLogin || '/account/login';
  }

  function isVisible(node) {
    if (!node) return false;
    try {
      var st = window.getComputedStyle(node);
      if (st.display === 'none' || st.visibility === 'hidden' || st.opacity === '0') return false;
      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } catch (e) {
      return false;
    }
  }

  function isKwikPassPresent() {
    try {
      if (
        document.querySelector(
          '#kp-login-button-header-logo, #kp-login-button-header-logo-mobile, [id^="kp-login-button"], #loggedin-icons, kp-account'
        )
      ) {
        return true;
      }
    } catch (e0) {}
    if (typeof window.handleKpAndShopifyLogin === 'function') return true;
    if (typeof window.kpHandleLogin === 'function') return true;
    if (typeof window.openIframe === 'function') return true;
    return Boolean(window.KwikPass || window.kwikPass || window.kp || window.KP);
  }

  function isKwikPassLoggedIn() {
    if (window.location.pathname.indexOf('/kp-account') !== -1) return true;
    try {
      if (document.querySelector('kp-account')) return true;
    } catch (e1) {}
    try {
      if (sessionStorage.getItem('isLogout') === 'true' || sessionStorage.getItem('isLogout') === '1') {
        return false;
      }
    } catch (e2) {}
    var loggedInIcons = document.getElementById('loggedin-icons');
    if (loggedInIcons && isVisible(loggedInIcons)) return true;
    var loginButton = document.querySelector(
      '#kp-login-button-header-logo, #kp-login-button-header-logo-mobile, [id^="kp-login-button"]'
    );
    if (loginButton) {
      try {
        if (window.getComputedStyle(loginButton).display === 'none') return true;
      } catch (e3) {}
    }
    return false;
  }

  function loginUiVisible() {
    var iframeSelectors = [
      'iframe[src*="kwikpass" i]',
      'iframe[src*="gokwik" i]',
      'iframe[src*="kp-account" i]',
    ];
    try {
      for (var i = 0; i < iframeSelectors.length; i++) {
        var iframes = document.querySelectorAll(iframeSelectors[i]);
        for (var j = 0; j < iframes.length; j++) {
          if (isVisible(iframes[j])) return true;
        }
      }
    } catch (e4) {}

    var nodeSelectors = [
      '#kwikpass-drawer-desktop',
      '#kwikpass-drawer-mobile',
      '.gokwik-modal',
      '.gk-modal',
      '[class*="kwikpass-iframe"]',
      '[class*="kp-iframe"]',
      '[id*="kwikpass-iframe"]',
    ];
    try {
      for (var k = 0; k < nodeSelectors.length; k++) {
        var nodes = document.querySelectorAll(nodeSelectors[k]);
        for (var m = 0; m < nodes.length; m++) {
          if (isVisible(nodes[m])) return true;
        }
      }
    } catch (e5) {}
    return false;
  }

  function dispatchClick(node) {
    if (!node) return false;
    try {
      node.dispatchEvent(
        new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
      );
      return true;
    } catch (e) {
      try {
        if (typeof node.click === 'function') {
          node.click();
          return true;
        }
      } catch (e2) {}
    }
    return false;
  }

  function clickNode(node) {
    if (!node || !isVisible(node)) return false;
    return dispatchClick(node);
  }

  function enableKwikPassHost() {
    var host =
      document.querySelector('.fineri-header__kp-host') ||
      document.querySelector('.fineri-header__app-embed-host');
    if (host) host.style.pointerEvents = 'auto';
  }

  function clickOneKwikPassButton() {
    var mobile = window.matchMedia && window.matchMedia('(max-width: 61.9375rem)').matches;
    var preferred = document.getElementById(
      mobile ? 'kp-login-button-header-logo-mobile' : 'kp-login-button-header-logo'
    );
    if (preferred) return dispatchClick(preferred);
    var kpBtn = document.querySelector(
      '#kp-login-button-header-logo, #kp-login-button-header-logo-mobile, [id^="kp-login-button"]'
    );
    return kpBtn ? dispatchClick(kpBtn) : false;
  }

  function openKwikPassOtp() {
    if (loginUiVisible()) return true;
    enableKwikPassHost();

    if (clickOneKwikPassButton()) return true;

    if (typeof window.openIframe === 'function') {
      try {
        window.openIframe();
        return true;
      } catch (e0) {}
    }
    if (typeof window.handleKpAndShopifyLogin === 'function') {
      try {
        window.handleKpAndShopifyLogin();
        return true;
      } catch (e1) {}
    }
    if (typeof window.kpHandleLogin === 'function') {
      try {
        window.kpHandleLogin('/account');
        return true;
      } catch (e2) {}
    }

    var apis = [window.KwikPass, window.kwikPass, window.kp, window.KP];
    for (var j = 0; j < apis.length; j++) {
      var api = apis[j];
      if (!api) continue;
      if (typeof api.openLogin === 'function') {
        try {
          api.openLogin();
          return true;
        } catch (e3) {}
      } else if (typeof api.showLogin === 'function') {
        try {
          api.showLogin();
          return true;
        } catch (e4) {}
      }
    }
    return false;
  }

  function retryKwikPassLogin() {
    if (kpRetryTimer) {
      window.clearTimeout(kpRetryTimer);
      kpRetryTimer = 0;
    }
    if (loginUiVisible()) return;
    if (openKwikPassOtp()) return;
    kpRetryTimer = window.setTimeout(function () {
      kpRetryTimer = 0;
      if (loginUiVisible()) return;
      openKwikPassOtp();
    }, 500);
  }

  function mountAccountDrawer() {
    var icons = document.querySelector('.fineri-header__icons');
    var drawer =
      document.getElementById('kwikpass-drawer-desktop') ||
      document.getElementById('kwikpass-drawer-mobile');
    if (!icons || !drawer) return null;
    if (drawer.parentElement !== icons) icons.appendChild(drawer);
    drawer.classList.add('fineri-header__kp-account-drawer');
    return drawer;
  }

  function openAccountDetails() {
    var drawer = mountAccountDrawer();
    if (!drawer) return false;
    var isOpen =
      drawer.style.display === 'block' || drawer.getAttribute('data-fineri-open') === 'true';
    if (isOpen) {
      drawer.style.display = 'none';
      drawer.setAttribute('data-fineri-open', 'false');
    } else {
      drawer.style.display = 'block';
      drawer.setAttribute('data-fineri-open', 'true');
    }
    return true;
  }

  function tryAppBridgeLogin() {
    if (isKwikPassPresent()) {
      retryKwikPassLogin();
      return true;
    }

    if (typeof window.openIframe === 'function') {
      try {
        window.openIframe();
        return true;
      } catch (e5) {}
    }
    if (typeof window.handleKpAndShopifyLogin === 'function') {
      try {
        window.handleKpAndShopifyLogin();
        return true;
      } catch (e6) {}
    }

    var kpBtns = document.querySelectorAll(
      '#kp-login-button-header-logo, #kp-login-button-header-logo-mobile, [id^="kp-login-button"]'
    );
    for (var i = 0; i < kpBtns.length; i++) {
      if (clickNode(kpBtns[i])) return true;
    }
    return false;
  }

  function goToLogin(url) {
    window.location.href = url || accountLoginUrl();
  }

  function scheduleFallback(url, delayMs) {
    var fired = false;
    var timer = window.setTimeout(function () {
      if (fired || loginUiVisible()) return;
      goToLogin(url);
    }, delayMs || FALLBACK_MS);

    return function cancel() {
      fired = true;
      window.clearTimeout(timer);
    };
  }

  /**
   * @param {Record<string, unknown>} [detail]
   */
  function runLoginFlow(detail) {
    detail = detail || {};
    var fallbackUrl = detail.returnUrl || accountLoginUrl();
    var kwikPassActive = isKwikPassPresent();

    if (shopifyCustomerLoggedIn()) {
      goToLogin(accountUrl());
      return { handled: true, method: 'shopify-account' };
    }

    if (isKwikPassLoggedIn()) {
      /* Already phone-logged-in — open account UI, do not re-trigger KP login/email popup. */
      if (!openAccountDetails()) goToLogin(accountUrl());
      return { handled: true, method: 'kwikpass-account' };
    }

    var cancelFallback = kwikPassActive ? function () {} : scheduleFallback(fallbackUrl, FALLBACK_MS);

    var ev;
    try {
      ev = new CustomEvent('fineri:login', {
        bubbles: true,
        cancelable: true,
        detail: detail,
      });
      document.dispatchEvent(ev);
    } catch (e) {
      ev = null;
    }

    if (tryAppBridgeLogin()) {
      if (!kwikPassActive) {
        [350, 900, 1400].forEach(function (ms) {
          window.setTimeout(function () {
            if (loginUiVisible()) cancelFallback();
          }, ms);
        });
      }
      return { handled: true, method: kwikPassActive ? 'kwikpass-otp' : 'app-bridge' };
    }

    if (ev && ev.defaultPrevented) {
      if (!kwikPassActive) {
        [350, 900, 1400].forEach(function () {
          window.setTimeout(function () {
            if (loginUiVisible()) cancelFallback();
          }, 350);
        });
      }
      return { handled: true, method: 'fineri-login-event' };
    }

    if (kwikPassActive) {
      retryKwikPassLogin();
      return { handled: true, method: 'kwikpass-retry' };
    }

    cancelFallback();
    goToLogin(fallbackUrl);
    return { handled: true, method: 'shopify-login' };
  }

  function onLoginClick(ev) {
    var el = ev.currentTarget;
    if (!el || shopifyCustomerLoggedIn()) return;
    ev.preventDefault();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    else if (typeof ev.stopPropagation === 'function') ev.stopPropagation();
    runLoginFlow({
      source:
        el.getAttribute('data-fineri-action-source') ||
        (el.hasAttribute('data-fineri-kwikpass-trigger') ? 'kwikpass-trigger' : 'login'),
      returnUrl: el.getAttribute('href') || accountLoginUrl(),
    });
  }

  function bindLoginTriggers() {
    document.querySelectorAll(LOGIN_TRIGGER_SELECTOR).forEach(function (el) {
      if (el.getAttribute('data-fineri-login-bound') === 'true') return;
      if (shopifyCustomerLoggedIn()) return;
      el.setAttribute('data-fineri-login-bound', 'true');
      if (el.nodeName === 'A') {
        var href = el.getAttribute('href') || '';
        if (!href || href === '#') {
          el.setAttribute('href', accountLoginUrl());
        }
      }
      el.addEventListener('click', onLoginClick, true);
    });
  }

  function observeLoginTargets() {
    ['.fineri-header__icons', '.fineri-header__drawer-account'].forEach(function (sel) {
      var root = document.querySelector(sel);
      if (!root || root.getAttribute('data-fineri-login-observed') === 'true') return;
      root.setAttribute('data-fineri-login-observed', 'true');
      new MutationObserver(bindLoginTriggers).observe(root, { childList: true, subtree: true });
    });
  }

  function initLoginBindings() {
    bindLoginTriggers();
    observeLoginTargets();
    window.setTimeout(bindLoginTriggers, 600);
    window.setTimeout(bindLoginTriggers, 2000);
    window.setTimeout(bindLoginTriggers, 4500);
  }

  window.fineriRunLoginFlow = runLoginFlow;
  window.fineriBindLoginTriggers = bindLoginTriggers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoginBindings, { once: true });
  } else {
    initLoginBindings();
  }

  document.addEventListener('update-dom', bindLoginTriggers);
})();
